import { createModule } from '../createModule';

export const employee = createModule('employee');